<template>
  <CContainer>
    <h3>Control Seguimiento de Documentos</h3>
    <CCard class="mt-4">
      <CCardBody>
        <CRow>
          <CCol col="sm-3">
            <label class="text-muted font-weight-bold">Fecha Inicial:</label>
            <DatePicker 
              type="date" 
              v-model="fechaInicial" 
              value-type="YYYY-MM-DD" 
              format="DD/MM/YYYY" 
              placeholder="dd/mm/aaaa" />
          </CCol>
          <CCol col="sm-3">
            <label class="text-muted font-weight-bold">Fecha Final:</label>
            <DatePicker
              type="date"
              v-model="fechaFinal"
              value-type="YYYY-MM-DD"
              format="DD/MM/YYYY"
              placeholder="dd/mm/aaaa" />
          </CCol>
          <CCol col="sm-4">
            <CAutocomplete
              label="Empleado:"
              :options="personal"
              @update:input="(newValue) => {
                idEmployee = newValue
              }">
            </CAutocomplete>
          </CCol>
          <CCol col="sm-2">
            <CButton 
              color="info" 
              variant="outline" 
              class="mt-4" 
              @click="getData()">
              <CIcon name="cil-search"/>
              <span class="ml-2 align-middle">Consultar</span>
            </CButton>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard class="mt-4">
      <CCardBody>
        <CDataTable
          hover
          pagination
          responsive 
          :fields="fields"
          :items="documents"
          :items-per-page="itemsPerPage">
          <template #documento="{item}">
            <td>
              <h4>{{ item.Prefijo }} {{ item.Numero }}</h4>
              <span>{{ item.Tipo_Documento }}</span>
            </td>
          </template>
          <template #empresa="{item}">
            <td>
              <div>
                <CIcon name="cil-building"/>
                <span class="ml-1">{{ item.Empresa }}</span>
              </div>
              <div>
                <i class="bi bi-postcard"></i>
                <span class="ml-1">{{ item.Identificacion }}</span>
              </div>
              <div>
                <i class="bi bi-geo-fill"></i>
                <span class="ml-1">{{ item.Direccion }}</span>
              </div>
              <div>
                <span>{{ item.Direccion_Auxiliar }}</span>
              </div>
            </td>
          </template>
          <template #empleados="{item}">
            <td>
              <div>
                <CIcon name="cil-truck"/>
                <span class="ml-1">{{item.Repartidor}}</span>
              </div>
              <div>
                <i class="bi bi-person-workspace mr-1"></i>
                <span>{{ item.Vendedor }}</span>
              </div>
            </td>
          </template>
          <template #registros="{item}">
            <td>
              <div>
                <CIcon name="cil-calendar"/>
                <span class="ml-1">{{ moment(item.FechaHora_Salida).format('DD/MM/YYYY') }}</span>
              </div>
              <div>
                <CIcon name="cil-clock"/>
                <span class="ml-1">{{ moment(item.FechaHora_Salida).format('HH:mm:ss') }}</span>
              </div>
              <div v-if="item.FechaHora_Entrada">
                <CIcon name="cil-calendar"/>
                <span class="ml-1">{{ moment(item.FechaHora_Entrada).format('DD/MM/YYYY') }}</span>
              </div>
              <div v-if="item.FechaHora_Entrada">
                <CIcon name="cil-clock"/>
                <span class="ml-1">{{ moment(item.FechaHora_Entrada).format('HH:mm:ss') }}</span>
              </div>
              <div>
                <a :href="`/seguimientopedido?id=${item.Id_Documento}`"
                  target="_blank"
                  @click="(event) => event.stopPropagation()">
                  <span class="text-dark">
                      <CIcon name="cil-location-pin" size="lg"></CIcon>
                  </span>
                </a>
                <a href="#" v-if="item.Path_Documento"
                  class="ml-1"
                  @click="(event) => getAttachedDocument(event, item.Path_Documento)">
                  <span class="text-warning">
                    <CIcon name="cil-paperclip" size="lg"></CIcon>
                  </span>
                </a>
              </div>
            </td>
          </template>
        </CDataTable>
      </CCardBody>

      <CElementCover  v-show="loading"/>
    </CCard>

    <RightSideBar size="lg" :show="showPanelImage" class="bg-s3grey">
      <CContainer>
        <CCard class="mt-3">
          <CCardHeader>
            <CCardTitle>
              Anexo Documento
            </CCardTitle>
            <CCardSubtitle>
              Imagen de soporte anexo
            </CCardSubtitle>
          </CCardHeader>
          <CCardBody>
            <div class="d-flex justify-content-center">
              <img v-if="!urlAttachedDocument" src="../../../public/static/imagen-no-disponible.gif" alt="Imagen documento anexo" />
              <URLImg v-if="urlAttachedDocument" :url="urlAttachedDocument" :key="updateComponent"/>
            </div>
          </CCardBody>
        </CCard>
        <div class="d-flex justify-content-center">
          <CButton 
            color="primary" 
            class="mb-3"
            @click="showPanelImage=false">
            <span>Cerrar</span>
          </CButton>
        </div>
      </CContainer>
    </RightSideBar>

  </CContainer>
</template>
<script>
  import "vue2-datepicker/index.css"
  import moment from "moment"
  import DatePicker from "vue2-datepicker"
  import { formatter } from "../../general"
  import CAutocomplete from "../containers/CAutocomplete.vue"
  import RightSideBar from "../containers/RightSideBar.vue"
  import URLImg from "../containers/URLImg.vue"
  import {
    dataGridControlDocumentos,
    dataListPersonal
  } from "../../api"

  const fields = [
    {
      key: "documento", 
      label: "Documento",
      _style:"text-align:center;"
    },
    {
      key: "empresa", 
      label: "Datos Entrega",
      _style:"text-align:center;"
    },
    {
      key: "empleados", 
      label: "Empleados",
      _style:"text-align:center;"
    },
    {
      key: "registros", 
      label: "Registros",
      _style:"text-align:center;"
    }
  ]
  export default {
    data() {
      return {
        fields,
        formatter,
        loading: false,
        showPanelImage: null,
        itemsPerPage: 5,
        updateComponent: 0,
        documents: [],
        personal: [],
        idEmployee: "",
        fechaInicial: "",
        fechaFinal: "",
        urlAttachedDocument: ""
      }
    },
    components: {
      DatePicker,
      CAutocomplete,
      URLImg,
      RightSideBar,
    },
    methods: {
      moment,
      async getData() {
        this.loading = true

        try {
          const { response } = await dataGridControlDocumentos(
            this,
            this.fechaInicial,
            this.fechaFinal,
            this.idEmployee ? this.idEmployee : null,
            this.$store.state.user.data.tipo_Empleado === "V" ? this.$store.state.user.data.id_Empleado : null,
          )
          this.documents = response
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al cargar datos",
            show: 5
          })
        } finally{
          this.loading = false
        }        
      },
      async getListPersonal() {
        try {
          const response = await dataListPersonal(this, "L")

          this.personal = response.map(item => {
            return {
              value: item.id_Personal,
              label: `${item.nombre_Empleado} - ${item.identificacion}`
            }
          })
        } catch {
          this.$store.commit("setAlert", {
              color: "danger",
              message: "Error al cargar datos",
              show: 5
            }
          )
        }
      },
      getAttachedDocument(e, pathAttached) {
        e.stopPropagation()

        this.showPanelImage = true

        if (pathAttached) {
          this.urlAttachedDocument = `/consultas/api/descargaArchivo?F=${pathAttached}`
          this.updateComponent += 1
        } else {
          this.urlAttachedDocument = ""
        }
      },
      getBadgeColor(item) {
        if(item.estado_EntregaMercancia === "P") return "danger"
        if(item.estado_EntregaMercancia === "F") return "success"
      }
    },
    created() {
      this.fechaInicial = moment().format("YYYY-MM-DD");
      this.fechaFinal = moment().format("YYYY-MM-DD");
    },
    async mounted() {
      await this.getListPersonal()

      this.getData()    
    }
  }
</script>